import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/locations/$state")({
  component: () => <Outlet />,
});
